import { render } from "./index.vue?vue&type=template&id=1620de5d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1620de5d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1620de5d"

export default script